import _styled from "@emotion/styled-base";
import React, { useCallback } from 'react';
import { themeableProperty } from '@risk-first/ui-style-utils';
import { rem, rgba } from 'polished';
const iconToggleVariants = {
  default: {
    sizes: {
      small: {
        width: rem(28),
        height: rem(28)
      },
      large: {
        width: rem(36),
        height: rem(36)
      }
    }
  }
};
const textToggleVariants = {
  default: {
    sizes: {
      small: {
        height: rem(28),
        padding: `0 ${rem(10)}`
      },
      large: {
        height: rem(36),
        padding: `0 ${rem(10)}`
      }
    }
  }
};

const baseToggleContainer = getVariantProperty => _styled("div", {
  target: "e13x3tx10"
})("display:flex;user-select:none;input[type='radio']{appearance:none;margin:0;}label{display:flex;align-items:center;justify-content:center;color:", getVariantProperty('color', '#1e90ff'), ";border:1px solid ", getVariantProperty('borderColor', '#1e90ff'), ";cursor:pointer;border-left-width:0;}label:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px;border-left-width:1px;}label:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px;}input[type='radio']:not(:disabled) + label:hover,input[type='radio']:not(:disabled) + label:focus{background-color:", getVariantProperty('color', '#1e90ff'), ";box-shadow:0 0 5px ", props => rgba(getVariantProperty('color', '#1e90ff')(props), 0.8), ";color:", getVariantProperty('bg', '#fff'), ";}@media screen{input[type='radio']:checked + label{background-color:", getVariantProperty('checked.bg', '#1e90ff'), ";color:", getVariantProperty('checked.color', '#fff'), ";}input[type='radio']:disabled + label{border-color:", getVariantProperty('disabled.borderColor', 'gray'), ";background-color:", getVariantProperty('disabled.bg', 'white'), ";color:", getVariantProperty('disabled.color', 'silver'), ";cursor:not-allowed;}input[type='radio']:checked:disabled + label{background-color:", getVariantProperty('disabled.checked.bg', 'silver'), ";color:", getVariantProperty('disabled.checked.color', 'white'), ";}}@media print{input[type='radio']:checked + label{border-width:3px;font-weight:bold;}input[type='radio']:disabled + label,input[type='radio']:checked:disabled + label{color:", getVariantProperty('color', '#1e90ff'), ";opacity:0.5;}}");

const getTextVariantProperty = themeableProperty('toggles.text', textToggleVariants);

const getTextVariantSizeProperty = (key, fallback) => props => getTextVariantProperty(`sizes.${props.size || 'default'}.${key}`, fallback)(props);

const TextToggleContainer = /*#__PURE__*/_styled(baseToggleContainer(getTextVariantProperty), {
  target: "e13x3tx11",
  label: "TextToggleContainer"
})("label{font-size:", getTextVariantSizeProperty('fontSize', '0.875rem'), ";height:", props => getIconVariantSizeProperty('height', rem(30))(props), ";padding:", getTextVariantSizeProperty('padding', rem(10)), ";}");

const getIconVariantProperty = themeableProperty('toggles.icon', iconToggleVariants);

const getIconVariantSizeProperty = (key, fallback) => props => getIconVariantProperty(`sizes.${props.size || 'default'}.${key}`, fallback)(props);

const IconToggleContainer = /*#__PURE__*/_styled(baseToggleContainer(getIconVariantProperty), {
  target: "e13x3tx12",
  label: "IconToggleContainer"
})("label{width:", props => getIconVariantSizeProperty('width', rem(30))(props), ";height:", props => getIconVariantSizeProperty('height', rem(30))(props), ";}");

const IconToggle = props => {
  const {
    disabled,
    name,
    onChange,
    options,
    size,
    value,
    variant = 'default'
  } = props;
  const handleChange = useCallback(event => onChange(event.currentTarget.value), [onChange]);
  return React.createElement(IconToggleContainer, {
    role: "radiogroup",
    size: size,
    variant: variant
  }, options.map(({
    value: optionValue,
    label,
    icon
  }) => React.createElement(React.Fragment, {
    key: optionValue
  }, React.createElement("input", {
    disabled: disabled,
    id: `toggle--${name}--${optionValue}`,
    type: "radio",
    name: name,
    onChange: handleChange,
    value: optionValue,
    checked: value === optionValue
  }), React.createElement("label", {
    "aria-label": label,
    htmlFor: `toggle--${name}--${optionValue}`
  }, React.createElement("div", {
    "aria-hidden": "true"
  }, icon)))));
};

const TextToggle = props => {
  const {
    disabled,
    name,
    onChange,
    options,
    size,
    value,
    variant = 'default'
  } = props;
  const handleChange = useCallback(event => onChange(event.currentTarget.value), [onChange]);
  return React.createElement(TextToggleContainer, {
    role: "radiogroup",
    size: size,
    variant: variant
  }, options.map(({
    value: optionValue,
    label
  }) => React.createElement(React.Fragment, {
    key: optionValue
  }, React.createElement("input", {
    disabled: disabled,
    id: `toggle--${name}--${optionValue}`,
    type: "radio",
    name: name,
    onChange: handleChange,
    value: optionValue,
    checked: value === optionValue
  }), React.createElement("label", {
    htmlFor: `toggle--${name}--${optionValue}`
  }, label))));
};

export { IconToggle, TextToggle };
//# sourceMappingURL=index.js.map
